export const EMIT_MAP = {
  onLeaveRoom: "leaveRoom",
  onEnterRoomSuccess: "enterRoomSuccess",
  onError: "error",
  onWarning: "warning",
  onUserVideoAvailable: "userVideoAvailable",
  onUserAudioAvailable: "userAudioAvailable",
  onRemoteUserEnterRoom: "remoteUserEnterRoom",
  onRemoteUserLeaveRoom: "remoteUserLeaveRoom",
  onTestMicVolume: "testMicVolume",
  onNetworkQuality: "networkQuality",
  onStatistics: "statistics",
  onRecvCustomCmdMsg: "recvCustomCmdMsg",
  onAudioVolumnChange: "audioVolumnChange",
  onKickedOut: "kickedOut",
  onScreenShareStop: "screenShareStop",
  // 设备变化（添加移除设备）
  onDeviceChange: "deviceChange",
  // 系统默认设备变化
  onDefaultDeviceChange: "defaultDeviceChange",
  // 设备启动
  onDeviceActive: "deviceActive",
  onUserSubStreamAvailable: "userSubStreamAvailable",
  onTryToReconnect: "tryToReconnect",
  onConnectionLost: "connectionLost",
  onConnectionRecovery: "connectionRecovery",
  onEnterRoomFail: "enterRoomFail",
  onCameraError: "cameraError",
  onMicrophoneError: "microphoneError",
  onSpeakerError: "speakerError",
  onScreenShareError: "screenShareError",
  onCustomCaptureError: "customCaptureError",
  onCodecError: "codecError",
};
